export default "__VITE_ASSET__b7b25db3__"